module.exports = __webpack_public_path__ + "static/media/display-2.d58470b9.png";